import { all, takeLatest, put, call } from 'redux-saga/effects';

import { deleteAuthCookie } from '@coconut/services/cookies';
import { STUDENT, LOGIN } from '@coconut/constants/landingRoutes';

import { logout } from '@coconut/services/apis/app';

import { types, removeToken } from '../redux/auth';
import { goToLandingPage } from '../redux/navigation';
import { cleanQuestions as cleanActiveQuestions } from '@coconut/scenes/Home/services/redux/activeQuestions';
import { cleanCompletedQuestions } from '@coconut/scenes/Home/services/redux/completedQuestions';
import { cleanProfile } from '@coconut/services/redux/profile';

function* cleanUserData() {
  yield put(removeToken());
  yield put(cleanActiveQuestions());
  yield put(cleanCompletedQuestions());
  yield put(cleanProfile());
  deleteAuthCookie();
}

function* forceLogoutFlow() {
  // Let Dragonfruit handle the flow (delete token)
  yield put(goToLandingPage(LOGIN));
}

function* logoutFlow() {
  yield call(logout);
  yield cleanUserData();

  // Sending the user back to the
  yield put(goToLandingPage(STUDENT));
}

export default function* () {
  yield all([
    takeLatest(types.FORCE_LOGOUT, forceLogoutFlow),
    takeLatest(types.LOGOUT, logoutFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/auth.js